import { React, useEffect, useState } from "react";
import PropTypes from "prop-types";
import { withTranslation } from "react-i18next";
import {
  showMessage,
  makeAjax,
  url,
  respStatus,
  currencyFormat,
  formatDate,
} from "../../../helpers/global_helper";

const PromotionRewardInner = (props) => {
  const [playerBonusDetail, setPlayerBonusDetail] = useState([]);

  const getPromotionBonus = () => {
    makeAjax(url.DPWD_API.listPlayerBonusInformation, [], url.DPWD_MS_EXT).then(
      (response) => {
        if (response?.status != respStatus["SUCCESS"]) {
          showMessage(response);
          return;
        }
        setPlayerBonusDetail(response?.data);
      }
    );
  };

  const formatFullDate = (dateStr) => {
    if(dateStr){
      const date = new Date(dateStr);
      return date.toLocaleDateString("en-US", {
        weekday: "long",
        year: "numeric",
        month: "long",
        day: "2-digit",
      });
    }
    
  };

  useEffect(() => {
    getPromotionBonus();
  }, []);

  return (
    <div className="promo-info">
      <div className="container">
        <div className="promo-info-div">
          <div className="promo-box">
            {console.log("playerBonusDetail", playerBonusDetail)}
            <h4 className="title ">{props.t("promotion_reward")}</h4>
            <table>
              <tbody>
                <tr>
                  <td>{props.t("promo_package")}</td>
                  <td>:</td>
                  <td className="data">{playerBonusDetail?.promotion_name ? playerBonusDetail.promotion_name : '-'}</td>
                </tr>
                <tr>
                  <td>{props.t("bonus_amount")}</td>
                  <td>:</td>
                  <td className="data">
                    IDR {currencyFormat(playerBonusDetail?.bonus_amount)}
                  </td>
                </tr>
                <tr>
                  <td>{props.t("target_turnover")}</td>
                  <td>:</td>
                  <td className="data">
                    IDR {currencyFormat(playerBonusDetail?.target_turnover)}{" "}
                    {playerBonusDetail?.expired_date && 
                    <strong>{props.t("before")}</strong>
                    }
                   {" "}
                    {formatFullDate(playerBonusDetail?.expired_date)}
                  </td>
                </tr>
                <tr>
                  <td>{props.t("turnover_reached")}</td>
                  <td>:</td>
                  <td className="data">
                  {playerBonusDetail?.turnover || 0}
                  </td>
                </tr>
                <tr>
                  <td>{props.t("vender")}</td>
                  <td>:</td>
                  <td className="data">
                    {playerBonusDetail?.provider_names || "-"}
                  </td>
                </tr>
                <tr>
                  <td>{props.t("category")}</td>
                  <td>:</td>
                  <td className="data">
                    {playerBonusDetail?.category_names || "-"}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

PromotionRewardInner.propTypes = {
  preGlobalFilteredRows: PropTypes.any,
};

export default withTranslation()(PromotionRewardInner);
